import Vue from 'vue';
import t from "@/service/SysMsgService";
import dictEnum from "@/constants/SysMsgDict";
import { Validator } from 'vee-validate';
export default function () {
    this.FinalPaymentVal = function () {
        const dictonary = {
            custom: {
                AdjAdd: {
                    required: () => t.t(dictEnum.LBL_Adjustment) + t.t(dictEnum.WARN_IsRequired)
                },
                IncType: {
                    required: () => t.t(dictEnum.LBL_IncType) + t.t(dictEnum.WARN_IsRequired)
                },
                IncSubType: {
                    required: () => t.t(dictEnum.LBL_IncSubType) + t.t(dictEnum.WARN_IsRequired)
                },
                Particular: {
                    required: () => t.t(dictEnum.LBL_Particular) + t.t(dictEnum.WARN_IsRequired)
                },
                DateTx: {
                    required: () => t.t(dictEnum.LBL_Date) + t.t(dictEnum.WARN_IsRequired)
                },
                Amt: {
                    required: () => t.t(dictEnum.LBL_Amount) + t.t(dictEnum.WARN_IsRequired)
                },
            }
        };
        Validator.localize('en', dictonary);
    }
}



// WEBPACK FOOTER //
// ./src/components/100000-Payroll/105000-FinalPayment/FinalPaymentVal.js